// // import React from 'react';
// // import check from '../../icons/icon_check.svg';
// // import sIcon1 from '../../icons/icon_man_question.svg';
// // import sIcon2 from '../../icons/icon_bulb.svg';


// // const SolutionSection = () => {
// //     return (
// //         <section className="problem_solution_section section_space pb-0">
// //             <div className="container">

// //                 <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="600">
// //                     <h2 className="heading_text mb-0">Our User Options</h2>
// //                     <br/>
// //                     <p>We offer two types of accounts on the Panda Sovereign platform, tailored to suit both individual and commercial needs. </p>
// //                 </div>                

// //                 <div
// //                     className="ico_problem_solution_table"
// //                     data-aos="fade-up"
// //                     data-aos-duration="600"
// //                     data-aos-delay="100"
// //                 >
// //                     <div className="column_wrapper">
// //                         {/* ICO Problem Section */}
// //                         <div className="column_problem">
// //                             <h3 className="heading_text">
// //                                 <span className="icon">
// //                                     <img src={sIcon1} alt="Icon Man With Question" />
// //                                 </span>
// //                                 <span className="text">Personal Account</span>
// //                             </h3>
// //                             <ul className="iconlist_block unordered_list_block">
// //                                 {[
// //                                     {
// //                                         label: 'Confidentiality',
// //                                         info: 'We prioritize the protection of your sensitive data using decentralized encryption technologies.',
// //                                     },
// //                                     {
// //                                         label: 'Security',
// //                                         info: 'Every personal interaction and transaction is fortified with blockchain-grade security to protect you from fraud and breaches.',
// //                                     },
// //                                     {
// //                                         label: 'Easy Access to Personal Data',
// //                                         info: 'Access and control your information without relying on third parties—your data, your rules.',
// //                                     },
// //                                     {
// //                                         label: 'Testing and Proactive Communication',
// //                                         info: 'Get early access to features and engage directly with our support and dev teams to shape future updates.',
// //                                     },
// //                                 ].map((item, index) => (
// //                                     <li key={index}>
// //                                         <span className="iconlist_icon">
// //                                             <img src={check} alt="Icon Check" />
// //                                         </span>
// //                                         <span className="iconlist_label">
// //                                             {item.label}
// //                                             <small className="iconlist_info">{item.info}</small>
// //                                         </span>
// //                                     </li>
// //                                 ))}
// //                             </ul>
// //                         </div>

// //                         {/* ICO Solution Section */}
// //                         <div className="column_solution">
// //                             <h3 className="heading_text">
// //                                 <span className="icon">
// //                                     <img src={sIcon2} alt="Icon Bulb" />
// //                                 </span>
// //                                 <span className="text">Commercial Account</span>
// //                             </h3>
// //                             <ul className="iconlist_block unordered_list_block">
// //                                 {[
// //                                     {
// //                                         label: 'Automation',
// //                                         info: 'Streamline business operations with automated tools and smart contract functionality.',
// //                                     },
// //                                     {
// //                                         label: 'Compliance with Regulations',
// //                                         info: 'Designed to support global regulatory standards—ensuring your business stays compliant and secure.',
// //                                     },
// //                                     {
// //                                         label: 'Building a New Financial Network',
// //                                         info: 'Contribute to the growth of a borderless, inclusive, and transparent digital economy.',
// //                                     },
// //                                     {
// //                                         label: 'Startups for Blockchain',
// //                                         info: 'Leverage our developer-friendly infrastructure to bring your blockchain vision to life—from MVP to market-ready dApps.',
// //                                     },
// //                                 ].map((item, index) => (
// //                                     <li key={index}>
// //                                         <span className="iconlist_icon">
// //                                             <img src={check} alt="Icon Check" />
// //                                         </span>
// //                                         <span className="iconlist_label">
// //                                             {item.label}
// //                                             <small className="iconlist_info">{item.info}</small>
// //                                         </span>
// //                                     </li>
// //                                 ))}
// //                             </ul>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </section>
// //     );
// // };

// // export default SolutionSection;

// import { useApi } from "../../hooks/useApi"
// import check from "../../icons/icon_check.svg"
// import sIcon1 from "../../icons/icon_man_question.svg"
// import sIcon2 from "../../icons/icon_bulb.svg"

// const SolutionSection = () => {
//   const { data: solutionData, loading, error } = useApi("/solution")

//   if (loading) {
//     return (
//       <section className="problem_solution_section section_space pb-0">
//         <div className="container">
//           <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
//             <div className="spinner-border text-primary" role="status">
//               <span className="sr-only">Loading...</span>
//             </div>
//           </div>
//         </div>
//       </section>
//     )
//   }

//   if (error || !solutionData) {
//     return null
//   }

//   return (
//     <section className="problem_solution_section section_space pb-0">
//       <div className="container">
//         <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="600">
//           <h2 className="heading_text mb-0">{solutionData.title}</h2>
//           <br />
//           <p>{solutionData.description}</p>
//         </div>

//         <div className="ico_problem_solution_table" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
//           <div className="column_wrapper">
//             {/* Personal Account Section */}
//             <div className="column_problem">
//               <h3 className="heading_text">
//                 <span className="icon">
//                   <img src={sIcon1 || "/placeholder.svg"} alt="Icon Man With Question" />
//                 </span>
//                 <span className="text">{solutionData.personalAccount?.title}</span>
//               </h3>
//               <ul className="iconlist_block unordered_list_block">
//                 {solutionData.personalAccount?.features?.map((feature, index) => (
//                   <li key={index}>
//                     <span className="iconlist_icon">
//                       <img src={check || "/placeholder.svg"} alt="Icon Check" />
//                     </span>
//                     <span className="iconlist_label">
//                       {feature.label}
//                       <small className="iconlist_info">{feature.info}</small>
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Commercial Account Section */}
//             <div className="column_solution">
//               <h3 className="heading_text">
//                 <span className="icon">
//                   <img src={sIcon2 || "/placeholder.svg"} alt="Icon Bulb" />
//                 </span>
//                 <span className="text">{solutionData.commercialAccount?.title}</span>
//               </h3>
//               <ul className="iconlist_block unordered_list_block">
//                 {solutionData.commercialAccount?.features?.map((feature, index) => (
//                   <li key={index}>
//                     <span className="iconlist_icon">
//                       <img src={check || "/placeholder.svg"} alt="Icon Check" />
//                     </span>
//                     <span className="iconlist_label">
//                       {feature.label}
//                       <small className="iconlist_info">{feature.info}</small>
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   )
// }

// export default SolutionSection

import { useApi } from "../../hooks/useApi"
import check from "../../icons/icon_check.svg"
import sIcon1 from "../../icons/icon_man_question.svg"
import sIcon2 from "../../icons/icon_bulb.svg"

const SolutionSection = () => {
  const { data: solutionData, loading, error } = useApi("/solution")

  // Default fallback data
  const defaultData = {
    title: "Our User Options",
    description:
      "We offer two types of accounts on the Panda Sovereign platform, tailored to suit both individual and commercial needs.",
    personalAccount: {
      title: "Personal Account",
      features: [
        {
          label: "Confidentiality",
          info: "We prioritize the protection of your sensitive data using decentralized encryption technologies.",
        },
        {
          label: "Security",
          info: "Every personal interaction and transaction is fortified with blockchain-grade security to protect you from fraud and breaches.",
        },
        {
          label: "Easy Access to Personal Data",
          info: "Access and control your information without relying on third parties—your data, your rules.",
        },
        {
          label: "Testing and Proactive Communication",
          info: "Get early access to features and engage directly with our support and dev teams to shape future updates.",
        },
      ],
    },
    commercialAccount: {
      title: "Commercial Account",
      features: [
        {
          label: "Automation",
          info: "Streamline business operations with automated tools and smart contract functionality.",
        },
        {
          label: "Compliance with Regulations",
          info: "Designed to support global regulatory standards—ensuring your business stays compliant and secure.",
        },
        {
          label: "Building a New Financial Network",
          info: "Contribute to the growth of a borderless, inclusive, and transparent digital economy.",
        },
        {
          label: "Startups for Blockchain",
          info: "Leverage our developer-friendly infrastructure to bring your blockchain vision to life—from MVP to market-ready dApps.",
        },
      ],
    },
  }

  // Use API data if available, otherwise use default
  const displayData = solutionData || defaultData

  if (loading) {
    console.log("Solution section loading...")
  }

  if (error) {
    console.error("Solution API error:", error)
  }

  return (
    <section className="problem_solution_section section_space pb-0">
      <div className="container">
        <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="600">
          <h2 className="heading_text mb-0">{displayData.heading}</h2>
          <br />
          <p>{displayData.subtitle}</p>
        </div>

        <div className="ico_problem_solution_table" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
          <div className="column_wrapper">
            {/* Personal Account Section */}
            <div className="column_problem">
              <h3 className="heading_text">
                <span className="icon">
                  <img src={sIcon1 || "/placeholder.svg"} alt="Icon Man With Question" />
                </span>
                <span className="text">{displayData.personalAccount?.title}</span>
              </h3>
              <ul className="iconlist_block unordered_list_block">
                {displayData.personalAccount?.features?.map((feature, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check || "/placeholder.svg"} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {feature.label}
                      <small className="iconlist_info">{feature.info}</small>
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Commercial Account Section */}
            <div className="column_solution">
              <h3 className="heading_text">
                <span className="icon">
                  <img src={sIcon2 || "/placeholder.svg"} alt="Icon Bulb" />
                </span>
                <span className="text">{displayData.commercialAccount?.title}</span>
              </h3>
              <ul className="iconlist_block unordered_list_block">
                {displayData.commercialAccount?.features?.map((feature, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check || "/placeholder.svg"} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {feature.label}
                      <small className="iconlist_info">{feature.info}</small>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SolutionSection
